/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Add Art Video</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5" >
                <div class="row">
                    <div class="form-group col-md-12">
                        <label>Title</label>
                        <input type="text" ref="title" id="" class="form-control mb-4" placeholder="title">
                    </div>
                    <div class="form-group col-md-12">
                        <label>Description</label>
                        <textarea ref="description" id="" class="form-control mb-4" rows="6" placeholder="Description">
                        </textarea>
                    </div>
                    <div class="form-group col-md-6">
                        <label>Vimeo Video</label>
                        <input type="text" ref="video" id="" class="form-control mb-4" placeholder="video id">
                    </div>
                    <div class="form-group col-md-6">
                        <label>Thumb</label>
                        <input type="file" ref="thumb" id="" class="form-control mb-4" accept="image/jpeg, image/png">
                    </div>
                </div>

                <!-- Sign in button -->
                <button class="btn btn-info btn-block my-4" @click.prevent="addVideo()">Add Video</button>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'AddArtVideo',
    components: {

    },
    data() {
        return {
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            loasing: false
        }
    },
    methods: {
        addVideo() {
            if(this.loading) return;
           
            if(this.$refs.title.value == '') {
                this.$toast.open({
                        message: "Error : Please add title",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.description.value == '') {
                this.$toast.open({
                        message: "Error : Please add description",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.video.value == '') {
                this.$toast.open({
                        message: "Error : Please add video",
                        type: 'error'
                    })
                return;
            }

            if(this.$refs.thumb.files.length == 0) {
                this.$toast.open({
                        message: "Error : Please add a thumbnail",
                        type: 'error'
                    })
                return;
            }

            let data = {
                title: this.$refs.title.value,
                description: this.$refs.description.value,
                video: this.$refs.video.value,
            }

            var reader1 = new FileReader()
                reader1.readAsDataURL(this.$refs.thumb.files[0])
                reader1.onload = () => {
                    data['thumb'] = reader1.result;
                    const config = {
                        headers: {
                            Authorization: "Bearer " + this.fastAdminToken,
                            'Content-Type': 'application/json'
                        }
                    }
                    this.$toast.open({
                        message: "Processing : Adding Avatar Assets. Please Wait...",
                        type: 'info'
                    })

                    this.loading = true;
                    axios.post(this.$apiURI + "/artvideo/create", data, config)
                        .then((response) => {
                            this.loading = false;
                            if (response.data.error) {
                                this.$toast.open({
                                    message: "Error : " + response.data.message,
                                    type: 'error'
                                });
                            } else {
                                this.$toast.open({
                                    message: "Avatar Assets Created Successfully",
                                    type: 'success'
                                })
                            }

                        }).catch((error) => {
                            this.loading = false;
                            this.$toast.open({
                                message: "Error : " + error.response.data.message,
                                type: 'error'
                            });
                        })
                };

            
        }
    }
}
</script>
